import Vue from 'vue';

Vue.component('consumed-ingredient-index', () =>
    import(/* webpackChunkName: 'index' */ './consumed-ingredient-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory-fnb/consumed-ingredient/index.js